import script from "./BucketListSection.vue?vue&type=script&setup=true&lang=js"
export * from "./BucketListSection.vue?vue&type=script&setup=true&lang=js"

import "./BucketListSection.vue?vue&type=style&index=0&id=5bdf2b9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdf2b9a"]])

export default __exports__